#import "../fragments/accounts-for-lead-fragment.graphql"
#import "../fragments/contacts-for-lead-fragment.graphql"

mutation RemoveAccountForLead($input: LeadRemoveAccountInput!) {
    leadRemoveAccount(input: $input) {
        lead {
            ...AccountsForLeadFragment
            ...ContactsForLeadFragment
        }
    }
}
